import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { makeGetTaskSubtasksCount, makeGetTaskCompletedSubtasksCount } from '../selectors/tasks';

import ProgressBarWithText from 'components/ProgressBarWithText';

const SubtasksOverview = ({ completedSubtasksCount, subtasksCount }) => {
    const { t } = useTranslation('common');

    const subtasksProgress = useMemo(() => {
        return Math.round(completedSubtasksCount / subtasksCount * 100)
    }, [completedSubtasksCount, subtasksCount]);

    if (!subtasksCount) {
        return null;
    }

    return (
        <div className="progress-wrapper">
            <div className="progress-wrapper-head">
                { t('Progress') }
            </div>

            <ProgressBarWithText value={completedSubtasksCount} total={subtasksCount} />
        </div>
    );
};

const makeMapStateToProps = () => {
    const getTaskSubtasksCount = makeGetTaskSubtasksCount();
    const getTaskCompletedSubtasksCount = makeGetTaskCompletedSubtasksCount();

    return ({ tasks }, ownProps) => ({
        subtasksCount: getTaskSubtasksCount(tasks.items, ownProps.taskId),
        completedSubtasksCount: getTaskCompletedSubtasksCount(tasks.items, ownProps.taskId)
    });
};

export default connect(makeMapStateToProps)(SubtasksOverview);
